<template>
  <div class="not-started">
    <div v-if="game.players.includes($store.state.auth.uid)">
      <h4>Zuwenige Spieler ({{ game.players.length }}/{{ game.requiredPlayers }})</h4>
      <br>
      Neue Spieler einladen mit: {{ location.origin }}/games/{{ game.hash }}
    </div>
    <div v-else-if="$store.state.auth.uid != null">
      <h5 class="mb-3">Hallo {{ $store.state.auth.username }}, willst du mitspielen?</h5>
      <BButton
        type="submit"
        variant="primary"
        class="mt-3"
        @click="onJoin"
        :disabled="isJoining"
      >
        Mitspielen
      </BButton>
    </div>
    <div v-else>
      <h5 class="mb-3">Zum Mitspielen Namen wählen:</h5>
      <BForm
        @submit.prevent="onJoinWithLogin"
      >
        <BFormInput
          v-model="username"
          class="mb-3"
          :state="(username == null) ? null : username.length >= 3"
          trim
        />
        <BButton
          type="submit"
          variant="primary"
          :disabled="username == null || username.length < 3 || isJoining"
        >
          Mitspielen
        </BButton>
      </BForm>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotStarted',
  props: {
    game: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      location: window.location,
      isJoining: false,
      username: null,
    };
  },
  methods: {
    async onJoinWithLogin() {
      this.isJoining = true;
      await this.$store.dispatch('auth/loginAnonymous', {
        username: this.username,
      });
      await this.onJoin();
    },
    async onJoin() {
      this.isJoining = true;
      await this.$store.dispatch('games/join', this.game);
      this.isJoining = false;
    },
  },
};
</script>

<style scoped>

</style>
